import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { NgForm, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { BackendService } from 'src/app/services/general/backend.service';

@Component({
    selector: 'app-pubmed-attachment',
    templateUrl: './pubmed-attachment.component.html',
    styleUrls: ['./pubmed-attachment.component.scss'],
    standalone: true,
    imports: [
        FormsModule,
        CommonModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatTableModule,
        MatPaginatorModule,
        MatProgressBarModule,
        MatIconModule,
        MatTooltipModule,
        TranslateModule
    ]
})
export class PubmedAttachmentComponent implements OnInit {

  @Output() attachElement: EventEmitter<any> = new EventEmitter();

  loading: boolean = false;

  modelSearch: any = {
    queryString: "",
    currentPage: 1
  };

  pubmedResults: any = {};
  pubmedResultsCached: any = {};

  //  table
  displayedColumns: string[] = ['ArticleTitle', 'Authors', 'PubYear', 'actions'];

  constructor(private backend: BackendService) { }

  ngOnInit(): void { }

  onSubmit(form: NgForm) {

    if (!form.form.valid)
      return;

    //  controllo se è cambiata la stringa di ricerca
    if (form.form.controls.queryString.value) {
      this.pubmedResultsCached = {};
    }

    //  faccio la ricerca
    this.searchTearmInPublmed(this.modelSearch.queryString, this.modelSearch.currentPage);
  }


  /**
   * Cerca un determinato valore su pubmed
   * @param query
   */
  searchTearmInPublmed(query: string, page: number = 1) {
    this.loading = true;

    //  restituisco i risultati cachati se ci sono (con breve delay per mostrare il loading)
    if (this.pubmedResultsCached[page]) {
      const cachedResult = this.pubmedResultsCached[page];
      setTimeout(() => {
        this.pubmedResults = cachedResult;
        this.loading = false;
      }, 200);
      return;
    }

    this.backend.post(`tools/pubmed/search`, {term: query, page: page}).subscribe((result) => {
      this.pubmedResultsCached[page] = result;
      this.pubmedResults = this.pubmedResultsCached[page];
      this.loading = false;
    }, (error) => {
      console.log(error);
      this.backend.showErrors(error);
      this.loading = false;
    })
  }


  /**
   * Evento di cambio pagina
   * @param event
   */
  pageChanged(event) {

    this.modelSearch.currentPage = event.pageIndex+1
    this.searchTearmInPublmed(this.modelSearch.queryString, this.modelSearch.currentPage);
  }



  /**
   * Premuto il bottone per aggiungere un articolo
   * @param element
   */
  addAttachment(element) {
    this.attachElement.emit(element);
  }
}
